<template>
    <div id="settings-stock-locations">
        <actions-menu>
            <actions-menu-item
                icon="arrow-left"
                :action="() => $router.push('/settings')"
                :v4="true"
                class="back"
                :label="trans('pages.stock_locations.back')"
            />
            <actions-menu-item
                icon="plus"
                :action="() => $router.push('/addstocklocation')"
                :v4="true"
                :label="trans('pages.stock_locations.add_new')"
            />
        </actions-menu>

        <pre
            v-if="isDebug"
            class="debug-info"
            >{{ locations }}</pre
        >
        <template v-if="!locations">
            <div
                class="error"
                v-if="fetchAllError"
            >
                {{ fetchAllError }}
            </div>
            <spinner-text v-else>
                {{ trans('pages.stock_locations.loading') }}
            </spinner-text>
        </template>
        <template v-else>
            <div class="filter">
                <ui5-input
                    type="Text"
                    :placeholder="
                        trans('pages.stock_locations.filter_placeholder')
                    "
                    :value="filter"
                    @input="filter = $event.target.value"
                >
                    <i
                        class="fa fa-filter"
                        slot="icon"
                    />
                </ui5-input>
            </div>
            <div class="items">
                <div
                    v-for="location in visibleLocations"
                    :key="'location.' + location.ID"
                >
                    <div class="item">
                        <div class="item-contents">
                            <div
                                v-if="location.editing"
                                class="form"
                            >
                                <ui5-input
                                    type="Text"
                                    :placeholder="
                                        trans(
                                            'pages.stock_locations.name_placeholder'
                                        )
                                    "
                                    :value="location.editLabel"
                                    @keyup.enter="saveEdit(location)"
                                    @input="
                                        location.editLabel = $event.target.value
                                    "
                                />
                                <ui5-textarea
                                    :placeholder="
                                        trans(
                                            'pages.stock_locations.description_placeholder'
                                        )
                                    "
                                    :value="location.editDescription"
                                    @input="
                                        location.editDescription =
                                            $event.target.value
                                    "
                                />
                                <div class="buttons">
                                    <ui5-button @click="cancelEdit(location)">
                                        {{
                                            trans(
                                                'pages.stock_locations.cancel'
                                            )
                                        }}
                                    </ui5-button>
                                    <ui5-button @click="saveEdit(location)">
                                        {{
                                            trans('pages.stock_locations.save')
                                        }}
                                    </ui5-button>
                                </div>
                            </div>
                            <template v-else>
                                <div class="label">
                                    <span v-if="isDebug">
                                        #{{ location.ID }} -
                                    </span>
                                    {{ location.label }}
                                </div>
                                <div class="description">
                                    {{ location.description }}
                                </div>
                            </template>
                        </div>
                        <div
                            class="actions"
                            v-if="!location.editing"
                        >
                            <spinner v-if="location.printing.small" />
                            <img
                                v-else
                                src="images/icons/print-pdf-s.svg"
                                @click="printLabel(location, 'small')"
                                :title="
                                    trans('pages.stock_locations.print_small')
                                "
                            />
                            <spinner v-if="location.printing.medium" />
                            <img
                                v-else
                                src="images/icons/print-pdf-m-landscape.svg"
                                @click="printLabel(location, 'medium')"
                                :title="
                                    trans('pages.stock_locations.print_medium')
                                "
                            />
                            <spinner v-if="location.printing.large" />
                            <img
                                v-else
                                src="images/icons/print-pdf-l.svg"
                                @click="printLabel(location, 'large')"
                                :title="
                                    trans('pages.stock_locations.print_large')
                                "
                            />

                            <div class="separator" />

                            <i
                                class="fa fa-file-pdf-o"
                                @click="exportLabel(location, 'large')"
                                :title="
                                    trans('pages.stock_locations.export_large')
                                "
                            />

                            <div class="separator" />

                            <img
                                src="images/icons/edit-alt.svg"
                                @click="location.editing = true"
                                :title="trans('pages.stock_locations.edit')"
                            />

                            <div class="separator" />

                            <img
                                src="images/icons/trash-alt.svg"
                                @click="promptRemove($event, location)"
                                :title="trans('pages.stock_locations.delete')"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <!--<div class="main-actions" v-if="locations">
        <spinner v-if="creating"/>
        <ui5-button v-else @click="create"><i class="fa fa-plus"/></ui5-button>
      </div>-->
            <ui5-dialog
                v-if="removeItem"
                class="confirm-remove-dialog"
                ref="confirmRemoveDialog"
                :header-text="trans('pages.stock_locations.title')"
            >
                <div class="dialog-contents">
                    <div>
                        {{ trans('pages.stock_locations.delete_confirmation') }}
                        <span v-if="isDebug">(#{{ removeItem.ID }})</span>
                    </div>
                    <div class="buttons">
                        <ui5-button @click="closeRemoveDialog">
                            {{ trans('pages.stock_locations.cancel') }}
                        </ui5-button>
                        <ui5-button @click="remove">
                            {{ trans('pages.stock_locations.delete_confirm') }}
                        </ui5-button>
                    </div>
                </div>
            </ui5-dialog>
        </template>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import SpinnerText from '../components/loader/SpinnerText';
import ErrorHelper from '../helpers/ErrorHelper';
import stockLocationApi from '../api/stockLocation';
import Spinner from '../components/loader/Spinner';
import IsDebugMixin from '../mixins/is-debug';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import _ from 'lodash';
import localization from '../mixins/localization';

export default {
    mixins: [IsDebugMixin, localization],
    data() {
        return {
            creating: false,
            fetchAllError: null,
            locations: null,
            filter: '',
            removeItem: null,
        };
    },
    methods: {
        exportLabel(location, size) {
            window.open(stockLocationApi.exportLabel(location.ID, size));
        },
        printLabel(location, size) {
            if (KeyHelper.isPressed('Shift')) {
                return window.open(stockLocationApi.exportLabel(location.ID, size));
            }

            location.printing[size] = true;
            stockLocationApi
                .printLabel(location.ID, size, this.selectedPrinterPostParameter)
                .then(() => {
                    showInfoMessage(
                        this.trans('pages.stock_locations.print_success')
                    );
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.stock_locations.print_error', {
                            errorMessage: ErrorHelper.parseError(
                                error.response.data
                            ),
                        })
                    );
                })
                .finally(() => {
                    location.printing[size] = false;
                });
        },
        create() {
            this.creating = true;
            stockLocationApi
                .create()
                .then(() => {
                    this.load();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.stock_locations.create_error', {
                            errorMessage: ErrorHelper.parseError(
                                error.response.data
                            ),
                        })
                    );
                })
                .finally(() => {
                    this.creating = false;
                });
        },
        restore(location) {
            location.editLabel = location.label;
            location.editDescription = location.description;
        },
        cancelEdit(location) {
            this.restore(location);
            location.editing = false;
        },
        saveEdit(location) {
            stockLocationApi
                .update(location.ID, {
                    label: location.editLabel,
                    description: location.editDescription,
                })
                .then(() => {
                    showInfoMessage(
                        this.trans('pages.stock_locations.save_success')
                    );
                    this.load();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.stock_locations.save_error', {
                            errorMessage: ErrorHelper.parseError(
                                error.response.data
                            ),
                        })
                    );
                });
        },
        closeRemoveDialog() {
            this.$refs.confirmRemoveDialog.close();
        },
        promptRemove(e, item) {
            this.removeItem = item;
            this.$nextTick(() => {
                const dialog = this.$refs.confirmRemoveDialog;
                dialog.show();
            });
        },
        remove() {
            stockLocationApi
                .remove(this.removeItem.ID)
                .then(() => {
                    this.load();
                    showInfoMessage(
                        this.trans('pages.stock_locations.delete_success')
                    );
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans('pages.stock_locations.delete_error', {
                            errorMessage: ErrorHelper.parseError(
                                error.response.data
                            ),
                        })
                    );
                })
                .finally(this.closeRemoveDialog);
        },
        load() {
            this.locations = null;
            this.fetchAllError = null;

            stockLocationApi
                .fetchAll()
                .then((response) => {
                    const locations = response.data.data;
                    locations.forEach((x) => {
                        x.editing = false;
                        x.label = x.label || '';
                        x.description = x.description || '';
                        x.editLabel = x.label;
                        x.editDescription = x.description;
                        x.printing = {
                            small: false,
                            medium: false,
                            large: false,
                        };
                    });
                    this.locations = locations;
                })
                .catch((error) => {
                    this.fetchAllError = this.trans(
                        'pages.stock_locations.load_error',
                        {
                            errorMessage: ErrorHelper.parseError(
                                error.response.data
                            ),
                        }
                    );
                });
        },
    },
    computed: {
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        visibleLocations() {
            return _.chain(this.locations)
                .filter(
                    (x) =>
                        !this.filter ||
                        (x.label && x.label.includes(this.filter)) ||
                        (x.description && x.description.includes(this.filter))
                )
                .sortBy('label')
                .value();
        },
    },
    mounted() {
        this.load();
    },
    components: { Spinner, SpinnerText, ActionsMenu, ActionsMenuItem },
};
</script>
